/** Mirrors server `mentionsContractReview` — keep file-part path for review intents. */
export function isContractReviewAttachmentIntent(text: string): boolean {
  const normalized = text.toLowerCase();
  if (/\bcontract[\s-]*review\b/.test(normalized)) return true;
  if (/\breview this\b/.test(normalized)) return true;
  const action = /\b(review|redline|red-line|analyze|analyse|assess)\b/.test(normalized);
  const target = /\b(contract|agreement|nda|msa|sow|addendum|document|pdf)\b/.test(normalized);
  return action && target;
}
